<nav class="main-navigation-sidenav">
  <app-heading [titleLevel]="3" [spacingBottom]="spacing">
    {{ title | translate }}</app-heading
  >

  <ul class="main-navigation-sidenav-section">
    @for (link of links; track link.label) { @if (hasAccess(link)) {
    <app-main-tab [link]="link"></app-main-tab>
    } }
  </ul>
</nav>
